import { Component } from "react";
import PropTypes from "prop-types";
import { ShoppingCart, RefreshCw } from "lucide-react";
import Button from "@shared/components/base/Button";

class CartErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Cart Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <div className="flex items-center">
            <ShoppingCart className="h-5 w-5 text-red-500 mr-2" />
            <h3 className="text-sm font-medium text-red-800">Cart Error</h3>
          </div>
          <p className="mt-2 text-sm text-red-700">
            There was an issue with your cart. Please refresh to continue
            shopping.
          </p>
          <Button
            onClick={() => window.location.reload()}
            className="mt-3"
            variant="secondary"
            size="sm"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Refresh Cart
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default CartErrorBoundary;
